import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { AffectedMethods } from './models';
/**
 * Error thrown when no processor is registered for the given entity subtype.
 *
 * @class UnsupportedEntityProcessorError
 * @extends {Error}
 */
export class UnsupportedEntityProcessorError extends Error {}
/**
 * Error thrown when no scheduling time value is invalid.
 *
 * @class InvalidSchedulingTimeValue
 * @extends {Error}
 */
export class InvalidSchedulingTimeValueError extends Error {
  constructor(timeDescription) {
    if (timeDescription === void 0) {
      timeDescription = 'value';
    }
    super(`${timeDescription} must be a zero or positive integer number`);
  }
}
/**
 * Error thrown when a scheduling time range lower bound is greater than the upper bound.
 *
 * @class SchedulingTimeRangeError
 * @extends {Error}
 */
export class SchedulingTimeRangeError extends Error {}
/**
 * Error thrown when a scheduling time range exceeds a business day (24 hours).
 *
 * @class SchedulingTimeExceedsBusinessDayError
 * @extends {Error}
 */
export class SchedulingTimeExceedsBusinessDayError extends Error {
  constructor(timeDescription) {
    if (timeDescription === void 0) {
      timeDescription = 'value';
    }
    super(`${timeDescription} can not exceed a business day`);
  }
}
/**
 * Error thrown when a preorder scheduling fulfillment windows value in minutes is smaller than the defined minimum.
 *
 * @class PreorderFulfillmentWindowsTooSmallError
 * @extends {Error}
 */
export class PreorderFulfillmentWindowsTooSmallError extends Error {}
/**
 * Error thrown when data inconsistency is found when trying to convert a Scheduling.
 *
 * @class UnsupportedSchedulingConversionError
 * @extends {Error}
 */
export class UnsupportedSchedulingConversionError extends Error {}
/**
 * Error thrown when ASAP scheduling preorder configurations are invalid.
 *
 * @class InvalidAsapFutureHandlingConfigError
 * @extends {Error}
 */
export class InvalidAsapFutureHandlingConfigError extends Error {}

/**
 * Time of day error
 *
 * @export
 * @class InvalidTimeOfDayError
 * @extends {Error}
 */
export class InvalidTimeOfDayError extends Error {
  constructor(unit, value) {
    super(`Time of day error: '${value}' exceeds ${unit} range`);
  }
}
export class InvalidDayOfWeekError extends Error {
  constructor(value) {
    super(`Invalid day of week: ${value}`);
  }
}
export class InvalidAvailabilitySlotError extends Error {
  constructor(message) {
    super(`Invalid Availability Slot: ${message}`);
  }
}
export class InvalidWeeklyAvailabilityError extends Error {
  constructor(message) {
    super(`Invalid Weekly Availability: ${message}`);
  }
}
export class InvalidRadiusOptionsError extends Error {
  constructor(message) {
    super(`Invalid Radius Options: ${message}`);
  }
}
export class InvalidCustomOptionsError extends Error {
  constructor(message) {
    super(`Invalid Custom Options: ${message}`);
  }
}
export class InvalidPostalCodeOptionsError extends Error {
  constructor(message) {
    super(`Invalid Postal Code Options: ${message}`);
  }
}
export class InvalidDeliveryAreaError extends Error {
  constructor(message) {
    super(`Invalid Delivery Area: ${message}`);
  }
}
export class InvalidGeocodeError extends Error {
  constructor(message) {
    super(`Invalid Geocode: ${message}`);
  }
}
export class InvalidFulfillmentMethodNameError extends Error {
  constructor(name) {
    super(`Invalid fulfillment method name: ${name}${name ? `(length: ${name.length})` : ''}`);
  }
}
export class InvalidFulfillmentMethodAmountError extends Error {
  constructor() {
    super('amount should be 0 or greater');
  }
}
export class InvalidServiceFeeRuleError extends Error {}
export class InvalidMoneyError extends Error {}
export class InvalidServiceFeeRuleName extends Error {}
export class InvalidServiceFeeRuleAmountError extends Error {}
export class InvalidServiceFeeRulePercentageError extends Error {}
export class InvalidServiceFeeRuleDecimalPlacesNumber extends Error {}
export class InvalidServiceFeeRuleConditionError extends Error {}
export class InvalidServiceFeeRuleNumberConditionError extends Error {}
export class InvalidServiceFeeRuleListConditionError extends Error {}
export class InvalidServiceFeeRuleConditionTreeError extends Error {}
export class InvalidAvailabilityExceptionError extends Error {}
export class InvalidAvailabilityExceptionAffectedFulfillmentMethodsError extends Error {
  constructor() {
    super(`Invalid availability exception affected fulfillment method - at least one fulfillment method id should be provided for ${AffectedMethods.SPECIFIC_FULFILLMENT_METHODS} scope`);
  }
}
export class InvalidTimezoneOffsetError extends Error {}
export class InvalidPickupInstructionsLengthError extends Error {}
export class InvalidMenuOrderingSettingsOperationIdError extends Error {}
export class UnsupportedMenuAvailabilityError extends Error {}
export class InvalidMenuOrderingSettingsWeeklyScheduleOption extends Error {}
export class InvalidMenuOrderingSettingsTimestampRangesOption extends Error {}
export class InvalidMenuOrderingSettingsTimestampRange extends Error {
  constructor(message, _ref) {
    let {
      range,
      index
    } = _ref;
    super(message);
    _defineProperty(this, "range", void 0);
    _defineProperty(this, "index", void 0);
    this.range = range;
    this.index = index;
  }
}
export class InvalidPacingError extends Error {
  constructor(message) {
    super(`Invalid Order Pacing: ${message}`);
  }
}
//# sourceMappingURL=errors.js.map